import interceptorAxios from './InterceptorAxios';

const servicioComplementoIne11={
    
    obtenerElementosIne11(urlObtenerElementosIne11){
        return interceptorAxios.post(urlObtenerElementosIne11);
    }

}
export default servicioComplementoIne11;